
import { Component, Vue, Watch } from "vue-property-decorator";


@Component({
  components: {},
})
export default class OnlineAttendantsList extends Vue {
  private users: any = {};
  private loading: boolean = true;

  @Watch("onlineUsers")
  onOnlineUsers() {
    this.refreshListUser();
  }

  @Watch("wsConnected", { immediate: true, deep: true })
  onWsConnected(val: any, oldVal: any) {
    if (val) {
      this.$store.dispatch("socketSendMessage", {
        action: "onlineUsers",
        platform_id: this.$auth.user().id_platform,
        user_id: this.$auth.user().id_user,
      });
      this.users = this.$store.state.socket.platformUsers;
      this.refreshListUser();
    }
  }
  private get wsConnected() {
    return this.$store.state.socket.isConnected;
  }

  private get onlineUsers() {
    return this.$store.state.socket.onlineUsers;
  }

  private refreshListUser() {
    this.loading = true;
    if (this.users.length > 0) {
      for (const key in this.users) {
        if (Object.prototype.hasOwnProperty.call(this.users, key)) {
          const user = this.users[key];
          this.users[key].isOnline = false;
          if (this.onlineUsers[user.id_user]) {
            if (
              this.onlineUsers[user.id_user].platform_id ==
              this.$auth.user().id_platform
            )
              this.users[key].isOnline = true;
          }
        }
      }

      this.users.sort((a, b) => {
        // Sort by online
        if (!a.isOnline && b.isOnline) return 1;
        if (a.isOnline && !b.isOnline) return -1;

        // Sort by name
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
      });
    }
    this.loading = false;
  }
}
